import React from 'react';
import PageLayout from '../components/PageLayout';

const TermsConditionsPage = () => {
  return (
    <PageLayout title="Terms and Conditions">
      <p>Last Updated: March 11, 2025</p>

      <h3>Agreement to Terms</h3>
      <p>
        By accessing or using our website and services, you agree to be bound by
        these Terms and Conditions. If you disagree with any part of the terms,
        you may not access our website or use our services.
      </p>

      <h3>Subscription Services</h3>
      <p>
        Curators' Studio offers premium flower subscription services on a weekly
        basis. By subscribing to our services, you agree to the following:
      </p>
      <ul>
        <li>
          Subscription payments will be automatically charged on a monthly basis
        </li>
        <li>
          Delivery schedules are based on your selected frequency (once, twice,
          or thrice weekly)
        </li>
        <li>
          We reserve the right to substitute flowers of equal or greater value
          if necessary due to availability
        </li>
        <li>
          Monthly subscription charges are calculated based on the average
          number of weeks in a month (4.33 weeks)
        </li>
      </ul>

      <h3>User Accounts</h3>
      <p>
        When you create an account with us, you must provide accurate, complete,
        and current information. You are responsible for safeguarding your
        account password and for any activities or actions under your account.
      </p>

      <h3>Payment Terms</h3>
      <p>
        All payments are processed securely through our payment partners. By
        providing payment information, you represent that you are authorized to
        use the payment method. You agree to pay all charges at the prices in
        effect when you incur the charges.
      </p>
      <p>
        Prices for our products are subject to change without notice. We reserve
        the right to modify or discontinue the service without notice at any
        time.
      </p>

      <h3>Intellectual Property</h3>
      <p>
        The website and its original content, features, and functionality are
        owned by Curators' Studio and are protected by international copyright,
        trademark, patent, trade secret, and other intellectual property laws.
      </p>

      <h3>User-Generated Content</h3>
      <p>
        By posting, uploading, or sharing any content on our website or social
        media platforms, you grant us a non-exclusive, royalty-free, worldwide,
        perpetual license to use, modify, publicly display, reproduce, and
        distribute such content on our platforms.
      </p>

      <h3>Limitation of Liability</h3>
      <p>
        In no event shall Curators' Studio, nor its directors, employees,
        partners, agents, suppliers, or affiliates, be liable for any indirect,
        incidental, special, consequential, or punitive damages, including
        without limitation, loss of profits, data, use, goodwill, or other
        intangible losses, resulting from:
      </p>
      <ul>
        <li>
          Your access to or use of or inability to access or use the service
        </li>
        <li>Any conduct or content of any third party on the service</li>
        <li>Any content obtained from the service</li>
        <li>
          Unauthorized access, use, or alteration of your transmissions or
          content
        </li>
      </ul>

      <h3>Governing Law</h3>
      <p>
        These Terms shall be governed and construed in accordance with the laws
        of India, without regard to its conflict of law provisions.
      </p>

      <h3>Changes to Terms</h3>
      <p>
        We reserve the right to modify or replace these Terms at any time. If a
        revision is material, we will try to provide at least 30 days' notice
        prior to any new terms taking effect.
      </p>

      <h3>Contact Us</h3>
      <p>If you have any questions about these Terms, please contact us at:</p>
      <p>
        Email: legal@curators.studio
        <br />
        Phone: +91 9008789490
        <br />
        Address: Gurugram, Haryana, India
      </p>
    </PageLayout>
  );
};

export default TermsConditionsPage;
